﻿$.fn.dxCtrlPopupSelectDestinataireMailing = function custom_dxCtrlPopupSelectDestinataireMailing(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlpopupselectdestinatairemailing dx-ctrl");
        this.createInstance(new cdxCtrlPopupSelectDestinataireMailing(this, option));
    }
    return this;
}

window.cdxCtrlPopupSelectDestinataireMailing = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.showAddRemove == "undefined") option.showAddRemove = true

    function mConstruit() {
        container.empty()
        var popChoix = container.appendTo("body").dxCtrlPopupBase({
            hideOnOutsideClick: false,
            width: 450,
            height: "auto",
            showTitle: true,
            showMaximize: false,
            title: (option.title ? option.title : "Que voulez vous faire"),
            contentTemplate: function (contentElement) {
                option.bddCtrl.mAjaxCall({
                    command: "getresumeenvoilstdata",
                    id: option.id
                }, function (data) {
                    if (!data.lst_dest) data.lst_dest = []
                    if (!data.lst_dest_click) data.lst_dest_click = []
                    if (!data.lst_dest_vue) data.lst_dest_vue = []
                    if (!data.lst_dest_non_click) data.lst_dest_non_click = []
                    if (!data.lst_dest_non_vue) data.lst_dest_non_vue = []
                    if (!data.lst_dest_non_interact) data.lst_dest_non_interact = []
                    if (!data.lst_dest_envoi) data.lst_dest_envoi = []
                    if (!data.lst_dest_annule) data.lst_dest_annule = []
                    if (data.lst_dest.length == 0) {
                        mNotify("Aucun destinataire pour ce mailing", "error", 6000)
                    } else {
                        var dxChkTot = null
                        if (data.lst_dest.length > 0) {
                            dxChkTot = $("<div style='margin:10px;'/>").appendTo(contentElement).dxCheckBox({
                                text: data.lst_dest.length + " destinataires au total"
                            }).dxCheckBox("instance")
                            $("<br/>").appendTo(contentElement)
                        }
                        var dxChkEnvoi = null
                        if (data.lst_dest_envoi.length > 0) {
                            dxChkEnvoi = $("<div style='margin:10px;'/>").appendTo(contentElement).dxCheckBox({
                                text: data.lst_dest_envoi.length + " destinataires qui ont reçu le mail"
                            }).dxCheckBox("instance")
                            $("<br/>").appendTo(contentElement)
                        }
                        var dxChkVue = null
                        if (data.lst_dest_vue.length > 0) {
                            dxChkVue = $("<div style='margin:10px;'/>").appendTo(contentElement).dxCheckBox({
                                text: data.lst_dest_vue.length + " destinataires qui ont vue"
                            }).dxCheckBox("instance")
                            $("<br/>").appendTo(contentElement)
                        }
                        var dxChkClick = null
                        if (data.lst_dest_click.length > 0) {
                            dxChkClick = $("<div style='margin:10px;'/>").appendTo(contentElement).dxCheckBox({
                                text: data.lst_dest_click.length + " destinataires qui ont cliqué"
                            }).dxCheckBox("instance")
                            $("<br/>").appendTo(contentElement)
                        }
                        var dxChkNoVue = null
                        if (data.lst_dest_non_vue.length > 0) {
                            dxChkNoVue = $("<div style='margin:10px;'/>").appendTo(contentElement).dxCheckBox({
                                text: data.lst_dest_non_vue.length + " destinataires qui n'ont pas vue"
                            }).dxCheckBox("instance")
                            $("<br/>").appendTo(contentElement)
                        }
                        var dxChkNoClick = null
                        if (data.lst_dest_non_click.length > 0) {
                            dxChkNoClick = $("<div style='margin:10px;'/>").appendTo(contentElement).dxCheckBox({
                                text: data.lst_dest_non_click.length + " destinataires qui n'ont pas cliqué"
                            }).dxCheckBox("instance")
                            $("<br/>").appendTo(contentElement)
                        }
                        var dxChkNoInteract = null
                        if (data.lst_dest_non_interact.length > 0) {
                            dxChkNoInteract = $("<div style='margin:10px;'/>").appendTo(contentElement).dxCheckBox({
                                text: data.lst_dest_non_interact.length + " destinataires qui n'ont pas interagi (ni vue, ni click)"
                            }).dxCheckBox("instance")
                            $("<br/>").appendTo(contentElement)
                        }
                        var dxChkAnnule = null
                        if (data.lst_dest_annule.length > 0) {
                            dxChkAnnule = $("<div style='margin:10px;'/>").appendTo(contentElement).dxCheckBox({
                                text: data.lst_dest_annule.length + " destinataires qui ont été annulé avant la fin de l'envoi"
                            }).dxCheckBox("instance")
                            $("<br/>").appendTo(contentElement)
                        }
                        if (option.showAddRemove) {
                            $("<hr/>").appendTo(contentElement)
                            var dxRadio = $("<div/>").appendTo(contentElement).dxRadioGroup({
                                layout: 'horizontal',
                                dataSource: ["Ajouter les destinataires", "Retirer les destinataires"],
                                value: "Ajouter les destinataires"

                            }).dxRadioGroup("instance")
                        }

                        mAddButtonOkAnnuler(contentElement,
                            function () { //ok
                                popChoix.hide();
                                var lstIdTableId = []
                                if (dxChkTot && dxChkTot.option("value")) lstIdTableId = lstIdTableId.concat(data.lst_dest)
                                if (dxChkEnvoi && dxChkEnvoi.option("value")) lstIdTableId = lstIdTableId.concat(data.lst_dest_envoi)
                                if (dxChkVue && dxChkVue.option("value")) lstIdTableId = lstIdTableId.concat(data.lst_dest_vue)
                                if (dxChkClick && dxChkClick.option("value")) lstIdTableId = lstIdTableId.concat(data.lst_dest_click)
                                if (dxChkNoVue && dxChkNoVue.option("value")) lstIdTableId = lstIdTableId.concat(data.lst_dest_non_vue)
                                if (dxChkNoClick && dxChkNoClick.option("value")) lstIdTableId = lstIdTableId.concat(data.lst_dest_non_click)
                                if (dxChkNoInteract && dxChkNoInteract.option("value")) lstIdTableId = lstIdTableId.concat(data.lst_dest_non_interact)
                                if (dxChkAnnule && dxChkAnnule.option("value")) lstIdTableId = lstIdTableId.concat(data.lst_dest_annule)

                                lstIdTableId = lstIdTableId.filter((item, index, self) =>
                                    index === self.findIndex(t =>
                                        t.id_table_destinataire === item.id_table_destinataire &&
                                        t.id_destinataire === item.id_destinataire
                                    )
                                );

                                option.onValide(lstIdTableId, (dxRadio ? dxRadio.option("value") : "Ajouter les destinataires"))
                            },
                            function () { //annuler
                                popChoix.hide();
                            }, "Annuler", "Valider").table.css("margin-top", "20px")
                    }
                })
            }
        }).dxCtrlPopupBase("instance")
        popChoix.show()
    }

    this.element = function () { return container }

    mConstruit();
}